module.exports = __webpack_public_path__ + "img/icon-mi-perfil.b24c8f7e.svg";